import React, { useState, useEffect, FunctionComponent, useCallback }  from "react";
import DefaultLayout from "layouts/Default";
import { Button, useMediaQuery } from "@material-ui/core";
import { BlogPost } from "services/entities/content";
import { loadBlogPosts } from "services/content";
import { handleError } from "util/errors";
import ProgressSpinner from "components/ProgressSpinner";
import "./index.scss";
import BlogPostCard from "../components/BlogPostCard";
import Banner from "../../../components/banner";
import BookingEnquiryForm from "../../../components/bookings/BookingEnquiryForm";
import TextMedia from "../../../components/textMedia";
import backgroundAsset from "../../../assets/img/steps/geo-1.svg";
import Trustpilot from "../../../components/trustpilot";
import { useTheme } from '@material-ui/core/styles';


interface BlogPageState {
  posts: BlogPost[] | null;
  displayedPosts: number;
}
interface BlogPageProps {
  
}
export const BlogPage: FunctionComponent<BlogPageProps> = () => {

  const theme = useTheme();
  const smallMedia = useMediaQuery(theme.breakpoints.down('sm'));

  const [blog, setBlog] = useState<BlogPageState>({
    posts: null,
    displayedPosts: 3,
  })

  const [postsPerPage, setPostsPerPage] = useState(6);

  const loadBlogPostsCallback = useCallback(() => {
    loadBlogPosts().then(
      (posts: BlogPost[]) => setBlog({...blog, posts: posts }),
      (err: any) => handleError("Failed loading articles", err)
    );
  }, [blog]);

  useEffect(() => {
    blog && blog.posts === null && loadBlogPostsCallback();
  },[loadBlogPostsCallback, blog])

  useEffect(() => {
    setPostsPerPage(smallMedia ? 6 : 9);
  },[smallMedia, setPostsPerPage])
  
  const onLoadMorePosts = () => {
    setPostsPerPage(postsPerPage + postsPerPage);
  };
  let posts: BlogPost[] | null = blog.posts;
  let hasMorePosts = false;
  if (posts && postsPerPage < posts!.length) {
    posts = posts!.slice(0, postsPerPage);
    hasMorePosts = true;
  }

   
    return (
      <DefaultLayout id="blog-page">
        <Banner title="Sookcess Stories" link={{}} />
        <BookingEnquiryForm />
        <TextMedia
          title="Meet the Community"
          text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur."
        />
        <span className="section-mw">
          <section className="content-mw section--posts">
            <div className="inner">
              {posts &&
                posts!.map((p, i) => <BlogPostCard key={i} blogPost={p} highlighted={p.highlighted} shortTitle={p.short_title} image={p.heroImage}  />)}
              {posts === null && <ProgressSpinner />}
              {posts !== null && posts!.length === 0 && (
                <p className="empty-message">No posts found</p>
              )}
            </div>
            {hasMorePosts && (
              <Button
                className="componnent-more"
                onClick={onLoadMorePosts}
              >
                See more
              </Button>
            )}
            <div className="background-image">
              {backgroundAsset && (
                <img src={backgroundAsset} alt="box illustration" />
              )}
            </div>
          </section>
        </span>
        <div className="section--trustpilot">
          <Trustpilot
            dataLocale="en-GB"
            dataTemplateId="5419b6a8b0d04a076446a9ad"
            dataBusinessunitId="613ce43d07226d001d53d3f6"
            dataStyleHeight="140px"
            dataStyleWidth="100%"
            dataTheme="light"
          />
        </div>
      </DefaultLayout>
    );
}

export default BlogPage;